import { api } from "@services/api";

type PostDownloadFicha = {
  cpf_colaborador: string;
  cnpj_cpf_comer: string;
  num_agenda?: string; // opcional: garante que a ficha correta seja retornada por agendamento
};

export async function postDownloadFicha(data: PostDownloadFicha) {
    return await api.post(`/ravim/colab-kit-salvo`, data);
}
